import React, { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import MyNavbar from './components/layout/MyNavbar';
import Whatsapp from './components/common/WhatsApp';
import { SearchProvider } from './context/SearchContext';
import { CarritoProvider } from './context/CarritoContext';
import Footer from './components/layout/Footer';
import ScrollToTop from './components/layout/ScrollToTop';
import Loader from './components/layout/Loader';
import Login from './pages/admin/Login';
import Admin from './pages/admin/Admin';
import AdminProductos from './pages/admin/AdminProductos';
import AdminEditarProducto from './pages/admin/AdminEditarProducto';
import AdminPedidos from './pages/admin/AdminPedidos';
import AdminLayout from './components/layout/AdminLayout';

const Home = lazy(() => import('./pages/public/Home'));
const Fundas = lazy(() => import('./pages/public/Fundas'));
const Accesorios = lazy(() => import('./pages/public/Accesorios'));
const Vidrios = lazy(() => import('./pages/public/Vidrios'));
const Carrito = lazy(() => import('./pages/public/Carrito'));
const CompraExitosa = lazy(() => import('./pages/public/CompraExitosa'));
const CompraError = lazy(() => import('./pages/public/CompraError'));
const CompraPendiente = lazy(() => import('./pages/public/CompraPendiente'));
const PedidoRegistrado = lazy(() => import('./pages/public/PedidoRegistrado'));
const TerminosYCondiciones = lazy(() => import('./pages/public/TerminosYCondiciones'));

function AppContent() {
  const location = useLocation();
  const isLogin = location.pathname === '/login';
  const isAdmin = location.pathname.startsWith('/admin');
  const isPedidosRoot = location.pathname === '/pedidos';
  const hideChrome = isLogin || isAdmin || isPedidosRoot;
  useEffect(() => {
    // Remove all route classes first
    document.body.classList.remove('login-route');
    document.body.classList.remove('chromeless-route');
    if (hideChrome) {
      document.body.classList.add('chromeless-route');
      if (isLogin) {
        document.body.classList.add('login-route');
      }
    }
    return () => {
      document.body.classList.remove('login-route');
      document.body.classList.remove('chromeless-route');
    };
  }, [hideChrome, isLogin]);
  return (
    <div className="App">
      <ScrollToTop />
      {!hideChrome && (
        <header>
          <MyNavbar />
        </header>
      )}
      {!hideChrome && <Whatsapp />}
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/fundas" element={<Fundas />} />
          <Route path="/accesorios" element={<Accesorios />} />
          <Route path="/vidrios" element={<Vidrios />} />
          <Route path="/carrito" element={<Carrito />} />
          <Route path="/compra-exitosa" element={<CompraExitosa />} />
          <Route path="/pedido-registrado" element={<PedidoRegistrado />} />
          <Route path="/checkout/failure" element={<CompraError />} />
          <Route path="/checkout/pending" element={<CompraPendiente />} />
          <Route path="/terminos-y-condiciones" element={<TerminosYCondiciones />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Admin />} />
            <Route path="productos" element={<AdminProductos />} />
            <Route path="productos/nuevo" element={<AdminEditarProducto />} />
            <Route path="productos/editar/:id" element={<AdminEditarProducto />} />
          </Route>
          <Route path="/pedidos" element={<AdminLayout />}>
            <Route index element={<AdminPedidos />} />
          </Route>
        </Routes>
      </Suspense>
      {!hideChrome && (
        <footer>
          <Footer />
        </footer>
      )}
    </div>
  );
}

function App() {
  return (
    <SearchProvider>
      <CarritoProvider>
        <Router>
          <AppContent />
        </Router>
      </CarritoProvider>
    </SearchProvider>
  );
}

export default App;
